import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import memoize from 'lodash.memoize';
import FolderCommentComponent from './FolderCommentComponent';
import PaginationWrapper from 'components/common/PaginationWrapper';
import { get, sequence } from '@totalsoft/change-tracking-react';
import { TextField } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import { CollapseCard } from '@totalsoft/rocket-ui';
import Assignment from '@mui/icons-material/Assignment';
import { RightsContext } from 'providers/RightsContext';

const FolderCommentsComponent = ({
  onRemoveItem,
  commentsLens,
  localRiskComment,
  onRiskCommentChanged,
  currentComment,
  onSaveItem,
  pagination,
  setCurrentComment,
  onRefresh,
  onChangePage,
  onChangeRowsPerPage,
  rowsPerPageOptions,
  saving
}) => {
  const handleRemove = memoize(commentId => () => {
    onRemoveItem(commentId);
  });
  const { readOnlyFull, riskAssesmentNotesHistoryRead, riskAssesmentNotesWrite } = useContext(RightsContext);
  const { t } = useTranslation();

  const editingItem = Boolean(currentComment);

  const setCommentIndex = (isEditing, index = null) => {
    if (index === null || index === undefined) return 0;
    return isEditing ? ++index : index;
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <TextField
          fullWidth
          value={localRiskComment || ''}
          onChange={onRiskCommentChanged}
          label={t('Folder.RiskComments.Title')}
          multiline
          rows={20}
          variant='outlined'
          disabled={readOnlyFull || !riskAssesmentNotesWrite}
          inputProps={{
            maxLength: 8000
          }}
        />
      </Grid>
      {riskAssesmentNotesHistoryRead && (commentsLens |> get).length > 0 && (
        <Grid item xs={12} sx={{ marginTop: 2 }}>
          <CollapseCard icon={Assignment} title={t('Folder.RiskComments.HistoryTitle')} hideSubheaderOnExpand toggleOnHeaderClick>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                {(commentsLens |> sequence).map((comment, idx) => {
                  return (
                    <Grid item xs={12} key={comment.riskCommentId |> get}>
                      <FolderCommentComponent
                        commentLens={comment}
                        deleteComment={handleRemove(comment.riskCommentId |> get)}
                        index={setCommentIndex(editingItem, idx)}
                        setCurrentComment={setCurrentComment}
                        onSaveItem={onSaveItem}
                        saving={saving}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <PaginationWrapper
                loading={false}
                count={pagination.totalCount}
                pageSize={pagination.pageSize}
                page={pagination.page}
                rowsPerPageOptions={rowsPerPageOptions}
                onRowsPerPageChange={onChangeRowsPerPage}
                onPageChange={onChangePage}
                onRefresh={onRefresh}
              />
            </Grid>
          </CollapseCard>
        </Grid>
      )}
    </Grid>
  );
};
FolderCommentsComponent.propTypes = {
  commentsLens: PropTypes.object.isRequired,
  localRiskComment: PropTypes.string.isRequired,
  onRiskCommentChanged: PropTypes.func.isRequired,
  onRemoveItem: PropTypes.func.isRequired,
  onSaveItem: PropTypes.func.isRequired,
  currentComment: PropTypes.object,
  changeCurrentComment: PropTypes.func.isRequired,
  onChangeRowsPerPage: PropTypes.func.isRequired,
  onChangePage: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired,
  pagination: PropTypes.object.isRequired,
  rowsPerPageOptions: PropTypes.array.isRequired,
  removeCurrentItem: PropTypes.func.isRequired,
  setCurrentComment: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired
};

export default FolderCommentsComponent;
